import { module } from 'modujs';
import { $html } from '../utils/dom';

export default class Header extends module {
  static CLASS_OPEN = 'has-menu-open';

  constructor(m) {
    super(m);
      this.$el = this.el
      this.$button = this.$('button')[0]

      this.events = {
        click: { 
           'button': 'toggle'
        }
      }
    }

    toggle(){ 
      if($html.classList.contains(Header.CLASS_OPEN)) {
        this.close();
      }
      else{ 
        this.open();
      }
    }

    close() {
      $html.classList.remove(Header.CLASS_OPEN);
      this.call('start', null, 'Scroll')
    }

    open(){ 
      $html.classList.add(Header.CLASS_OPEN);
      this.call('stop', null, 'Scroll')
    }

    theme({ theme, oldTheme }) {
      this.$el.classList.remove(`is-${oldTheme}`)
      this.$el.classList.add(`is-${theme}`)
    }
    

    destroy() {
     super.destroy();
    }

  }
